// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PostMenu__item--admin":"qn_a","PostMenu__item--moderator":"qn_b","PostMenu__item--author":"qn_c"};